<template>
    <div class="list-container">
        <h2>Manage Time Slots</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/time-slots/create')">Add Time Slot</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="slot in timeSlots" :key="slot.id" class="list-item">
                <div class="item-info">
                    <span class="info-item"><strong>Start Time:</strong> {{ formatTime(slot.start_time) }}</span>
                    <span class="info-item"><strong>End Time:</strong> {{ formatTime(slot.end_time) }}</span>
                </div>

                <div class="btn-group">
                    <button class="btn btn-sm edit-btn"
                        @click="$router.push(`/dashboard/time-slots/edit/${slot.id}`)">✏️
                        Edit</button>
                    <button class="btn btn-sm delete-btn" @click="deleteTimeSlot(slot.id)">Delete</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timeSlots: [],
            loading: false
        };
    },
    methods: {
        formatTime(time) {
            if (!time) return 'N/A';
            const [hours, minutes] = time.split(':');
            let h = parseInt(hours);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12; // Convert 0 to 12 for 12 AM
            return `${h}:${minutes} ${ampm}`;
        },
        async fetchTimeSlots() {
            this.loading = true;
            try {
                const response = await this.$api.get('/time-slots');
                this.timeSlots = response.data;
            } catch (error) {
                console.error("Error fetching time slots:", error);
            }
            this.loading = false;
        },
        async deleteTimeSlot(id) {
            if (!confirm("Are you sure you want to delete this time slot?")) return;
            try {
                await this.$api.delete(`/time-slots/${id}`);
                this.timeSlots = this.timeSlots.filter(slot => slot.id !== id);
            } catch (error) {
                console.error("Error deleting time slot:", error);
            }
        }
    },
    mounted() {
        this.fetchTimeSlots();
    }
};
</script>

<style scoped>
.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
